var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('a-layout-content',[_c('div',{class:{
        [_vm.$style.container]: true,
      }},[_c('div',{class:_vm.$style.containerInner},[_c('transition',{class:_vm.$style.containerInner,attrs:{"name":_vm.settings.routerAnimation,"mode":"out-in"}},[_c('router-view')],1)],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }